import Request from '../utilis/request';

export function getCategories(params) {
    return Request({
        url:'/api/categories',
        method:'get',
        params: params
    })
}

export function saveCategory(data) {
    return Request({
        url:'/api/categories',
        method:'post',
        data: data
    })
}
export function updateCategory(id, data) {
    return Request({
        url:'/api/categories/'+id,
        method:'post',
        data: data
    })
}

export function saveOrder(data) {
    return Request({
        url:'/api/categories/order',
        method:'post',
        data: data
    })
}
